export default __webpack_public_path__ + "548aa84dc4518851c3b7dd54c9691efc.svg";